import React, { useCallback, useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import BeaconFilterItem from '../../../models/BeaconFilterItem';
import stateMeasures from '../../../state/stateMeasures';
import stateFilterMeasure from '../../../state/stateFilterMeasure';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { Grid } from '@mui/material';
import BeaconFilterItemRequest from 'models/BeaconFilterItemRequest';

const operators: any[] = [
  { label: '=', id: '=' },
  { label: '!=', id: '!=' },
  { label: '<', id: '<' },
  { label: '<=', id: '<=' },
  { label: '>', id: '>' },
  { label: '>=', id: '>=' },
];

function QueryMeasure() {
  const [measures] = useRecoilState(stateMeasures);
  const [filterMeasure, setFilterMeasure] = useRecoilState(stateFilterMeasure);
  const [measure, setMeasure] = useState(
    null as BeaconFilterItemRequest | null
  );
  const [operator, setOperator] = useState('');
  const [measureValue, setMeasureValue] = useState(null as string | null);

  const [errorMeasure, setErrorMeasure] = useState(null as string | null);
  const [errorOperator, setErrorOperator] = useState(null as string | null);
  const [errorMeasureValue, setErrorMeasureValue] = useState(
    null as string | null
  );

  useEffect(() => {
    if (!!measure && !!operator && !!measureValue) {
      setErrorMeasure(null);
      setErrorOperator(null);
      setErrorMeasureValue(null);
      setFilterMeasure({
        id: measure.id,
        operator: operator.id,
        value: measureValue,
      });
    } else {
      if (filterMeasure) {
        setFilterMeasure(null);
      }
      if (!measure && !operator && !measureValue) {
        setErrorMeasure(null);
        setErrorOperator(null);
        setErrorMeasureValue(null);
      } else {
        if (!measure) {
          setErrorMeasure('Required field');
        } else {
          setErrorMeasure(null);
        }

        if (!operator) {
          setErrorOperator('Required field');
        } else {
          setErrorOperator(null);
        }

        if (!measureValue) {
          setErrorMeasureValue('Required field');
        } else {
          setErrorMeasureValue(null);
        }
      }
    }
  }, [measure, operator, measureValue]);

  const handleChangeMeasure = useCallback(
    (
      event: React.SyntheticEvent<Element, Event>,
      measure: BeaconFilterItem | null
    ) => {
      setMeasure(measure);
    },
    [setMeasure]
  );

  const handleChangeOperator = useCallback(
    (event: React.Select<Element, Event>, operator: any | null) => {
      setOperator(operator);
    },
    [setOperator]
  );

  const handleChangeValue = useCallback(
    (event: React.HTMLTextAreaElement<Element, Event>) => {
      const value = (event.target.value || '').trim();
      setMeasureValue(value);
    },
    [setMeasureValue]
  );

  if (0 < measures.length) {
    return (
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6}>
          <Autocomplete
            fullWidth
            disablePortal
            options={measures}
            // sx={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="dense"
                helperText={errorMeasure}
                error={!!errorMeasure}
              />
            )}
            value={measure}
            onChange={handleChangeMeasure}
            size="small"
          />
        </Grid>

        <Grid item xs={3}>
          <Autocomplete
            fullWidth
            disablePortal
            options={operators}
            // sx={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="dense"
                helperText={errorOperator}
                error={!!errorOperator}
              />
            )}
            value={operator}
            onChange={handleChangeOperator}
            size="small"
          />
        </Grid>

        <Grid item xs={3}>
          <TextField
            variant="outlined"
            onChange={handleChangeValue}
            helperText={errorMeasureValue}
            error={!!errorMeasureValue}
            size="small"
          />
        </Grid>
      </Grid>
    );
  } else {
    return <CircularProgress />;
  }
}

export default QueryMeasure;
